import { ruleRunner, run } from 'validations/ruleRunner';
import { maximum, minimun, required } from 'validations/rules';

export const schema = [
  ruleRunner('weight', 'Peso', required, minimun(1)),
  ruleRunner('height', 'Altura', required, minimun(1), maximum(100)),
  ruleRunner('width', 'Largura', required, minimun(1), maximum(100)),
  ruleRunner('length', 'Comprimento', required, minimun(1), maximum(100))
];

export const validate = (delivery: any, validations: any) => {
  return run(delivery, validations);
};

export const isValid = (obj: { [key: string]: string }, key: string) => {
  return obj[key] ? true : false;
};
